<template>
  <div class="w-full">
    <div v-for="(s, si) in form_schema" :key="si">
      <h3 v-if="show_label" class="text-2xl font-light mb-2 pb-1 border-b">{{s.label}}</h3>
      <div v-if="showValidationIndicator" class="text-center font-bold text-red-700">**Please Complete all required fields before submitting**</div>
      <div class="flex flex-wrap">
        <div v-for="(d, di) in s.fields" :key="di" :data-field="d.model" class="w-full" :class="{'mb-2': true, 'p-1': true, 'w-full': (!d.width || d.width == 'full'),'md:w-1/2': d.width == 'half'}">
          <template v-if="isAdmin || !d.admin_only">
            <div v-if="d.type!='submit'" >
              <label class="block text-gray-900 text-sm font-bold mb-1" :for="d.model">
                <span v-if="d.required" class="text-sm text-red-600 mr-1">*</span>{{d.label}}
              </label>
              <field-input
                v-if="fieldInputTypes.includes(d.type)"
                :field="d"
                :value="s.model[d.model]"
                :country="country"
                :invalid="doValidation && d.required && !checkField(s.model, d)"
                @input="v => $set(s.model, d.model, v)"
              />
              <template v-else-if="d.type === 'file'">
                <FilePondUploadWrapper :dataObject="s.model" :field="String(d.model)"/>
              </template>
              <template v-else-if="d.type === 'calculated'">
                <input type="text" :value="calculateFieldValue(d, s.model)" readonly class="text-input bg-gray-100 cursor-not-allowed" :class="{'invalid-form-input': doValidation && d.required && !checkField(s.model, d)}">
                <p class="text-xs text-gray-500 mt-1">This field is automatically calculated</p>
              </template>
              <template v-else-if="d.type=='json'">
                <div class="">
                  <v-jsoneditor v-model="s.model[d.model]" :options="{mode:'code'}" :plus="false" height="400px" class="mb-4"/>
                </div>
              </template>
              <div>
                <a v-if="d.link" :href="d.link" target="_blank" class="link">{{d.link_label ? d.link_label : `View ${d.label}`}}</a>
                <p class="text-sm text-gray-700 mt-1" v-if="d.hint" v-html="linkify(d.hint)"></p>
              </div>
            </div>
            <template v-else>
              <button @click="d.onSubmit" class="btn btn-blue" type="button">
                {{d.buttonText}}
              </button>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
import FilePondUploadWrapper from '@/components/FilePondUploadWrapper.vue'
import FieldInput, {FIELD_INPUT_TYPES} from '@/components/FieldInput.vue'
import {calculateFieldValue} from '@/utils/calculatedFields'

export default {
  props: {
    form_schema: Array,
    show_label: {
      type: Boolean,
      default: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    country: {
      type: String,
      default: 'US'
    }
  },
  components: {
    VJsoneditor,
    FilePondUploadWrapper,
    FieldInput
  },
  data () {
    return {
      fieldInputTypes: FIELD_INPUT_TYPES,
      doValidation: false,
      showValidationIndicator: false
    }
  },
  methods: {
    checkField (object, f) {
      let isValid = true
      if (f.required) {
        if (!(f.inputType === 'number' && object[f.model] === 0) && !object[f.model]) {
          isValid = false
        }
      }
      return isValid
    },
    calculateFieldValue (field, dataModel) {
      return calculateFieldValue(field, dataModel)
    },
    validateForm () {
      let isValid = true
      this.form_schema.forEach(s => {
        s.fields.forEach(f => {
          if (f.required) {
            if (!(f.inputType === 'number' && s.model[f.model] === 0) && !s.model[f.model]) {
              isValid = false
            }
          }
        })
      })

      this.doValidation = true
      this.showValidationIndicator = !isValid
      return isValid
    }
  }
}
</script>

<style>

</style>
